const FALLBACK_CHANGELOG_ENTRY = {
  version: '3.0.0002',
  date: '27.04.2026',
  title: 'Обновление Salew Bot',
  items: [
    'Мелкое улучшение.',
  ],
};

const normalizeChangelogEntry = (entry) => {
  if (!entry || typeof entry !== 'object') {
    return null;
  }

  const items = Array.isArray(entry.items)
    ? entry.items
      .map((item) => String(item || '').trim())
      .filter(Boolean)
    : [];

  return {
    version: String(entry.version || '').trim(),
    date: String(entry.date || '').trim(),
    title: String(entry.title || '').trim() || 'Что нового',
    items,
  };
};

export const getLatestChangelogEntry = () => (
  normalizeChangelogEntry(FALLBACK_CHANGELOG_ENTRY)
);

export const fetchLatestChangelogEntry = async () => {
  const baseUrl = process.env.PUBLIC_URL || '';
  const response = await fetch(
    `${baseUrl}/changelog.json?ts=${Date.now()}`,
    {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
      },
    }
  );

  if (!response.ok) {
    throw new Error(`changelog_http_${response.status}`);
  }

  const payload = await response.json();
  if (Array.isArray(payload)) {
    return normalizeChangelogEntry(payload[0]);
  }

  if (Array.isArray(payload?.entries)) {
    return normalizeChangelogEntry(payload.entries[0]);
  }

  return normalizeChangelogEntry(payload);
};
